import { useInfiniteQuery } from '@tanstack/react-query';
import { useTagsContext } from './useTagsContext';
import { tagsQueries } from '../utils/queries';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';

import { useMemo } from 'react';

const TAGS_PAGE_SIZE = 100;

export const useInfinityTagsQuery = (
  searchText: string,
  options?: { enabled?: boolean; minTime?: number },
) => {
  const { type, fetchTags } = useTagsContext();

  const enabled = options?.enabled ?? true;
  const minTime = options?.minTime ?? 0;

  const { data, ...queryProps } = useInfiniteQuery({
    queryKey: tagsQueries.infinityList(type, { search: searchText, pageSize: TAGS_PAGE_SIZE }),
    queryFn: async ({ pageParam }) => {
      if (minTime > 0) {
        return setMinimalPromiseTime(
          fetchTags({ search: searchText, pageSize: TAGS_PAGE_SIZE, pageNumber: pageParam }),
          minTime,
        );
      }

      return fetchTags({ search: searchText, pageSize: TAGS_PAGE_SIZE, pageNumber: pageParam });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.length >= TAGS_PAGE_SIZE) {
        return pages.length + 1;
      }
    },

    enabled,
  });

  const tags = useMemo(
    () =>
      data?.pages.reduce((acc, value) => {
        return [...acc, ...value];
      }, []) || [],
    [data],
  );

  return {
    tags,
    ...queryProps,
  };
};
